import type { ScheduleComponent } from '@syncfusion/ej2-react-schedule'

export function safeRefreshScheduleEvents(schedule: ScheduleComponent | null): void {
  if (!schedule) return

  const root = schedule as unknown as {
    isDestroyed?: boolean
    activeView?: { startDate?: () => Date }
  }

  if (root.isDestroyed || !root.activeView || typeof root.activeView.startDate !== 'function') {
    return
  }

  try {
    schedule.refreshEvents(false)
  } catch {
    /* view not fully initialized */
  }
}

export function revertScheduleDomChange(schedule: ScheduleComponent | null): void {
  if (!schedule) return

  const crudObj = (
    schedule as unknown as {
      crudModule?: {
        crudObj?: { isCrudAction: boolean; sourceEvent: unknown; targetEvent: unknown }
      }
    }
  ).crudModule?.crudObj

  if (crudObj) {
    crudObj.isCrudAction = false
    crudObj.sourceEvent = null
    crudObj.targetEvent = null
  }

  safeRefreshScheduleEvents(schedule)
}
